import { FormDropdown } from '@src/common/components/FormDropdown';
import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import { ControllerFormNumberInput } from '@src/orders/PermitFormSections/ControllerFormNumberInput';
import { ControllerFormCheckbox } from '@src/orders/PermitFormSections/FormCheckbox';
import { FormDatePicker } from '@src/orders/PermitFormSections/FormDatePicker';
import {
  TractorLicenseEffectiveDateField,
  TractorLicenseExpirationDateField,
  TractorLicenseIsApportionedPlateField,
  TractorLicensePlateTypeField,
  TractorLicensePlateYearField,
} from '@src/permitField/TractorLicenseFields';
import type { Control } from 'react-hook-form';

interface Props {
  control: Control;
}

export const TractorLicenseForm = ({ control }: Props) => {
  return (
    <Stack direction="column" gap={theme.spacing['3']}>
      <FormDatePicker
        isUTC
        control={control}
        fieldName={TractorLicenseEffectiveDateField.fieldName}
      />
      <FormDatePicker
        isUTC
        control={control}
        fieldName={TractorLicenseExpirationDateField.fieldName}
      />
      <FormDropdown
        control={control}
        fieldName={TractorLicensePlateTypeField.fieldName}
        options={TractorLicensePlateTypeField.options.map((option) => ({
          value: option,
          label: option,
        }))}
      />
      <ControllerFormNumberInput
        control={control}
        fieldName={TractorLicensePlateYearField.fieldName}
      />
      <ControllerFormCheckbox
        control={control}
        fieldName={TractorLicenseIsApportionedPlateField.fieldName}
      />
    </Stack>
  );
};
